module.exports = __webpack_public_path__ + "static/media/home-qiyepeixun.05115bf4.png";